export default __webpack_public_path__ + "static/media/DAIF_Services_Clean.65fc3b37.jpg";